import { render, staticRenderFns } from "./TemplateAdd.vue?vue&type=template&id=6df63949&"
import script from "./TemplateAdd.vue?vue&type=script&lang=js&"
export * from "./TemplateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports